import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as paymentService from "../../services/payment.services";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Breadcrums from "../../common/breadcrumbs";
import * as usersService from "../../services/seller.services";
import {
    capitalizeFirstLetter,
    formateDateWithMonth,
    formateDateWithMonthAdmin,
    handleServerValidations,
    TrimText,
} from "../../../../utils/commonfunction";
import CustomRangepicker from "../../common/rangepicker";
import StatusFilter from "../../common/statusFilter";
import { Tooltip, Whisper, Placeholder } from "rsuite";
import * as $ from 'jquery';
import { useSearchParams } from "react-router-dom";


const Transactions = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [list, setList] = useState([]);

    const [statsupdate, setStatusUpdate] = useState("false");
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [resetdate, setResetDate] = useState(false);
    const [searchParams] = useSearchParams();

    const [globalsearch, setGlobalSearch] = useState("");
    const [search, setSearch] = useState({
        ...(searchParams.get("status") ? { payment_status: searchParams.get("status") } : {}),
    });
    console.log(search, 222);

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("sidebar_link_payment"), url: "" },
    ];
    const showInquiryFilterList = [
        { name: "list_heading_status", status__id: "" },
        { name: "Completed", status__id: "completed" },
        { name: "Pending", status__id: "pending" },
        { name: "Failed", status__id: "failed" },
    ];

    useEffect(() => {
        console.log(params, "check");
        const getData = setTimeout(() => {

            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("_id", params.id);
                formData.append("page", params.pgno);
                formData.append("per_page", itemperpage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalsearch);
                console.log(formData)
                usersService
                    .payementDetails(formData)
                    .then((data) => {
                        setDataLength(data.data.total_records);
                        // setSerialNo(data.data.offset);
                        setList(data && data.data && data.data.list ? data?.data?.list : []);
                        // console.log("data.data.=====>", data.data);

                        setPage(data && data.data && data.data.page ? data.data.page : 1);
                        setLoader(false);
                    })
                    .catch((error) => {
                        console.log("error ====> ", error);
                    });
            }

        }, 300);
        return () => clearTimeout(getData)

    }, [
        location,
        statsupdate,
        sorting,
        search,
        globalsearch,
        itemperpage,
        params.pgno,
    ]);


    const viewfunction = (row) => {
        navigate(
            `/admin/payment/view/${row._id}`
        );
    };


    // sorting function start
    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    };
    // sorting end

    // search or filter function

    const prepareSearch = (key, value) => {

        console.log('key---', key, value)
        const statusLabelMap = {
            "completed": "completed",
            "pending": "pending",
            "failed": "failed",
        };

        let sr;

        if (statusLabelMap[value]) {
            sr = { "payment_status": statusLabelMap[value] };
        }

        else {
            sr = { ...search };
            if (String(value).length > 0) {
                sr[key] = value;
            } else {
                delete sr[key];
            }
        }

        if (value && typeof value === "string" && value.toLowerCase() === "status") {
            sr = {};
        }




        console.log('sr---', sr)
        setSearch(sr);
    };


    // search or filer end

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        setResetDate(!resetdate);
        $("#defaultstatus")[0].selectedIndex = 0;
    };


    return (
        <>
            {/* <Breadcrums data={breadcrumbs} /> */}
            {/* table section */}
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">
                                {t("sidebar_link_payment")}
                            </h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="form-group mb-0 rangepicker_container filter_design">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input
                                            type="search"
                                            className="form-control"
                                            value={globalsearch}
                                            placeholder={t("input_placeholder_search")}
                                            onChange={(e) => {
                                                setGlobalSearch(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="me-3">
                                    <CustomRangepicker
                                        GetDateRange={(e) => {
                                            prepareSearch("createdAt", e);
                                        }}
                                        resetdate={resetdate}
                                    />
                                </div>
                                <div className="me-3">
                                    <StatusFilter
                                        data={showInquiryFilterList}
                                        prepareSearch={prepareSearch}
                                        selectedStatus={search?.payment_status || ""}
                                    />
                                </div>

                                <button
                                    type="reset"
                                    value="Reset"
                                    onClick={resetFilter}
                                    className="btn btn-warning float-right mr-2"
                                >
                                    {t("btn_reset_filter")}
                                </button>
                            </div>
                        </div>
                        {loader ?
                            <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            :
                            <>
                                <div className="table-responsive min-h-400">
                                    <table className="table table-bordered border-t0 table table-bordered card-table border-top text-nowrap w-100 text-nowrap w-100">
                                        <thead>
                                            <tr>
                                                <th className="position-relative select_head">
                                                    <span>{t("list_heading_sno")}</span>
                                                </th>


                                                {/* <th className="status_head">{t("list_heading_status")}</th> */}
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("list_heading_name")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            column="name"
                                                        />
                                                    </div>
                                                </th>




                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("label_email")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            column="email"
                                                        />
                                                    </div>
                                                </th>



                                                <th>
                                                    <div className="rating_head">
                                                        <span>payment method</span>
                                                    </div>
                                                </th>


                                                <th>
                                                    <div className="rating_head">
                                                        <span>{t("list_heading_status")}</span>
                                                    </div>
                                                </th>

                                                <th>
                                                    <div className="rating_head">
                                                        <span>Amount</span>
                                                    </div>
                                                </th>

                                                {/* <th className="status_head">SUBSCRIBE</th> */}
                                                <th className="created_head">
                                                    <div className="sorting_column">
                                                        <span>{t("label_payment_date")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            defaultSorting={defaultSorting}
                                                            column="createdAt"
                                                        />
                                                    </div>
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <>
                                                {list.length ? (
                                                    list.map((row, i) => {
                                                        return (
                                                            <tr
                                                                key={i}
                                                            >

                                                                <td>
                                                                    {row ? ((page - 1) * itemperpage) + i + 1 : null}
                                                                </td>

                                                                <td>
                                                                    {row?.name ? (
                                                                        <div className="d-flex">
                                                                            {row?.name ? TrimText(row.name, 50) : "N/A"}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="d-flex">"N/A"</div>
                                                                    )}
                                                                </td>




                                                                <td>
                                                                    {row?.email ? (
                                                                        <div className="d-flex">{TrimText(row.email, 50)}</div>
                                                                    ) : (
                                                                        <div className="d-flex">N/A</div>
                                                                    )}
                                                                </td>



                                                                <td>
                                                                    {row?.payment_method ? (
                                                                        <div className="d-flex">{capitalizeFirstLetter(row.payment_method)}</div>
                                                                    ) : (
                                                                        <div className="d-flex">N/A</div>
                                                                    )}
                                                                </td>


                                                                <td>
                                                                    {row?.payment_status ? (
                                                                        <div className="d-flex">{capitalizeFirstLetter(row.payment_status)}</div>
                                                                    ) : (
                                                                        <div className="d-flex">N/A</div>
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    {row?.package_price ? (
                                                                        <div className="d-flex">{t(row.package_price)}</div>
                                                                    ) : (
                                                                        <div className="d-flex">N/A</div>
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    {row.createdAt
                                                                        ? formateDateWithMonthAdmin(row.createdAt)
                                                                        : "N/A"}
                                                                </td>


                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={10} className="text-center">
                                                            {t("msg_no_records")}
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        </tbody>
                                    </table>
                                </div>
                                <div
                                    className=""
                                    id="example1_info"
                                    role="status"
                                    aria-live="polite"
                                >
                                    <b>
                                        {t("msg_total_records")} : {datalength ? datalength : "0"}
                                    </b>
                                </div>
                                {datalength && datalength > 0 ? (
                                    <CustomPagination
                                        datalength={datalength}
                                        itemperpage={itemperpage}
                                        currentPage={page}
                                        setPage={setPage}
                                        pageRoute={[
                                            {
                                                name: "Reataurant",
                                                path: `/admin/streamers/view/${params.id}/transactions`,
                                            },
                                        ]}
                                    />
                                ) : (
                                    ""
                                )}
                            </>
                        }
                    </div>
                </div>
            </div>

        </>
    );
};

export default Transactions;
